// Mock data for GVRewards leaderboard (frontend-only teaser)
import { reloadBonus, rewardPrograms } from "./content/rewards";

export const brand = {
  name: "GVRewards",
  affiliateCode: "GREENVENOM",
  prizePool: 25000,
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Leaderboard", to: "/leaderboard", badge: "$25K" },
  { label: "VIP Rewards", to: "/vip-rewards" },
  { label: "Wager Rewards", to: "/rewards" },
  { label: "Challenges", to: "/#features" },
];

// End date for the countdown -> end of the current month (UTC)
export const getCompetitionEnd = () => {
  const now = new Date();
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1, 0, 0, 0));
};

export const topThree = [
  {
    rank: 2,
    user: "**XSLXSIX**",
    wagered: 612957.64,
    prize: 6000,
  },
  {
    rank: 1,
    user: "**banianBar**",
    wagered: 796225.00,
    prize: 10000,
  },
  {
    rank: 3,
    user: "**nexTheGoa**",
    wagered: 477548.03,
    prize: 3500,
  },
];

export const leaderboard = [
  { rank: 4, user: "**quant**", wagered: 359886.71, prize: 2000 },
  { rank: 5, user: "**vernd**", wagered: 262743.57, prize: 1500 },
  { rank: 6, user: "**nnabets**", wagered: 229625.46, prize: 1200 },
  { rank: 7, user: "**ter1**", wagered: 155135.72, prize: 1000 },
  { rank: 8, user: "**xitr67**", wagered: 116372.21, prize: 800 },
  { rank: 9, user: "**lschyTV**", wagered: 91528.10, prize: 700 },
  { rank: 10, user: "**eez**", wagered: 87763.68, prize: 600 },
  { rank: 11, user: "**kyro88**", wagered: 72410.55, prize: 500 },
  { rank: 12, user: "**mavrik**", wagered: 61285.30, prize: 400 },
  { rank: 13, user: "**zephy7**", wagered: 54120.18, prize: 350 },
  { rank: 14, user: "**drfnbet**", wagered: 47660.42, prize: 300 },
  { rank: 15, user: "**olex22**", wagered: 39840.09, prize: 250 },
  { rank: 16, user: "**punchz**", wagered: 33215.63, prize: 200 },
  { rank: 17, user: "**vireo9**", wagered: 28470.20, prize: 175 },
  { rank: 18, user: "**kkr993**", wagered: 22195.77, prize: 150 },
  { rank: 19, user: "**sunkd**", wagered: 17530.40, prize: 125 },
  { rank: 20, user: "**orbit0**", wagered: 12880.11, prize: 100 },
];

// Stake Exclusive board ($5,000 pool)
export const exclusiveSettings = {
  prizePool: 5000,
  affiliateCode: "GREENVENOM",
};

export const exclusiveTopThree = [
  { rank: 2, user: "**Vip***x92**", wagered: 28450.10, prize: 1000 },
  { rank: 1, user: "**Kin***gGV**", wagered: 61230.55, prize: 2000 },
  { rank: 3, user: "**Ace***h07**", wagered: 15980.40, prize: 750 },
];

export const exclusiveLeaderboard = [
  { rank: 4, user: "**Sly***ox4**", wagered: 9820.12, prize: 400 },
  { rank: 5, user: "**Nit***ro9**", wagered: 7415.66, prize: 300 },
  { rank: 6, user: "**Blz***z11**", wagered: 5240.90, prize: 200 },
  { rank: 7, user: "**Qwe***rty**", wagered: 3880.33, prize: 150 },
  { rank: 8, user: "**Lun***a22**", wagered: 2960.47, prize: 100 },
  { rank: 9, user: "**Emb***er7**", wagered: 2140.18, prize: 60 },
  { rank: 10, user: "**Zap***p00**", wagered: 1520.05, prize: 40 },
];


const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const previousMonths = (() => {
  const list = [];
  const now = new Date();
  for (let i = 1; i <= 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    list.push({
      id: `${d.getFullYear()}-${d.getMonth()}`,
      label: `${months[d.getMonth()]} ${d.getFullYear()}`,
      winners: 20,
      prizePool: 20000,
    });
  }
  return list;
})();

export const rules = [
  {
    title: "How to Participate",
    body:
      "Play on Stake.com using the affiliate code GREENVENOM. All wagers placed under this code are automatically tracked and count towards your position on the leaderboard.",
  },
  {
    title: "Wager Counting Rules",
    body:
      "To maintain fair competition, wager contributions are adjusted based on the game's return-to-player (RTP) percentage.",
    bullets: [
      "Games with RTP ≤ 98% — 100% counts",
      "Games with RTP > 98% — 50% counts",
      "Games with RTP ≥ 99% — 10% counts",
    ],
  },
  {
    title: "Results & Payouts",
    body:
      "The leaderboard resets on the 1st of each month at midnight UTC. Results may take up to 48 hours to publish after the competition period ends. Prizes are paid out in USDC (ERC20).",
  },
  {
    title: "Fair Play",
    body:
      "Wagers are tracked automatically through Stake's affiliate system. Any form of abuse or fraudulent activity will result in immediate disqualification. GVRewards reserves the right to modify prizes and rules at any time.",
  },
];

export const formatUSD = (n) =>
  n.toLocaleString("en-US", { style: "currency", currency: "USD" });

// ---- Wager Rewards / Level Up tiers ----
export const wagerTiers = [
  { rank: "Bronze", tier: "bronze", requirement: 10000, reward: 10 },
  { rank: "Silver", tier: "silver", requirement: 50000, reward: 30 },
  { rank: "Gold", tier: "gold", requirement: 100000, reward: 50 },
  { rank: "Platinum 1", tier: "platinum", requirement: 250000, reward: 125 },
  { rank: "Platinum 2", tier: "platinum", requirement: 500000, reward: 250 },
  { rank: "Platinum 3", tier: "platinum", requirement: 1000000, reward: 500 },
  { rank: "Platinum 4", tier: "platinum", requirement: 2500000, reward: 1250 },
  { rank: "Platinum 5", tier: "platinum", requirement: 5000000, reward: 2500 },
  { rank: "Platinum 6", tier: "platinum", requirement: 10000000, reward: 5000 },
  { rank: "Diamond", tier: "diamond", requirement: 25000000, reward: 10000 },
];


// ---- Home page mock data ----
export const homeStats = [
  { id: 'monthly-prize-pool', program: 'leaderboard', label: "Monthly Prize Pool", value: 25000, prefix: "$" },
  { id: 'weekly-lossback', program: 'lossback', label: "Weekly Lossback", value: 10, prefix: "", suffix: "%" },
  { id: 'wager-rewards', program: 'wager', label: "Wager Rewards", value: 10000, prefix: "$", suffix: "+" },
  { id: 'reload-bonus', program: 'reload', label: "Free Reload Bonus", value: 21, prefix: "$", suffix: "", cents: true },
];

export const features = [
  {
    id: "lossback",
    icon: "RotateCcw",
    title: rewardPrograms.lossback.title,
    tag: "Weekly cashback",
    desc: rewardPrograms.lossback.description,
    cta: "Learn More",
  },
  {
    id: "levelup",
    icon: "TrendingUp",
    title: rewardPrograms.wager.title,
    tag: "Wager rewards",
    desc: rewardPrograms.wager.description,
    cta: "View Levels",
    to: "/rewards",
  },
  {
    id: "leaderboard",
    icon: "Trophy",
    title: rewardPrograms.leaderboard.title,
    tag: "Monthly cash prizes",
    desc: rewardPrograms.leaderboard.description,
    cta: "View Leaderboard",
    to: "/leaderboard",
  },
  {
    id: "reload-bonus",
    icon: "Gift",
    title: reloadBonus.title,
    tag: "Reload bonus",
    desc: reloadBonus.description,
    cta: "View Bonus",
    to: "/vip-rewards",
  },
];

export const liveWins = [
  { user: "Max***P1s", game: "Sweet Bonanza", amount: 98044.5 },
  { user: "Chr***tor", game: "Gates of Olympus", amount: 13022.74 },
  { user: "Nov***te6", game: "Sugar Rush", amount: 7451.1 },
  { user: "Lev***Flo", game: "Wanted Dead", amount: 5210.0 },
  { user: "yel***e17", game: "Crash", amount: 3980.6 },
  { user: "AAo***nee", game: "Plinko", amount: 2145.25 },
  { user: "Kin***gGV", game: "Money Train 4", amount: 18760.4 },
  { user: "Vip***x92", game: "The Dog House", amount: 6120.9 },
];

export const youtubeChannel = {
  name: "GreenVenom",
  url: "https://www.youtube.com/@GreenVenom",
};

export const latestVideos = [
  {
    id: 1,
    title: "MY LUCK WAS ON FIRE TODAY! (NON-STOP WINS!)",
    age: "16 hours ago",
    thumb: "https://static.prod-images.emergentagent.com/jobs/42f730f5-aab1-4168-8558-489ad8ebe93f/images/00f47d4a930e5a49350e93fd90536cb82b992fe3620f4a5d53cb8112c36a1eaf.jpeg",
  },
  {
    id: 2,
    title: "I had ABSOLUTELY INSANE LUCK on ORIGINALS!",
    age: "1 day ago",
    thumb: "https://static.prod-images.emergentagent.com/jobs/42f730f5-aab1-4168-8558-489ad8ebe93f/images/9305fd4732ffa3210ff2ec71e8a0d9e4cbaa11d78cbc773f6a82a38cbe7907fa.jpeg",
  },
  {
    id: 3,
    title: "I GAMBLED MY $5,000 AND THIS HAPPENED!",
    age: "2 days ago",
    thumb: "https://static.prod-images.emergentagent.com/jobs/42f730f5-aab1-4168-8558-489ad8ebe93f/images/1b7edf2a5c0d768cc1dc73373ac38ce580ca21681f84794bc42ffe88d6fcd077.jpeg",
  },
  {
    id: 4,
    title: "THE *NEW* MINTED MIKE SLOT IS AMAZING! (BIG WIN)",
    age: "3 days ago",
    thumb: "https://static.prod-images.emergentagent.com/jobs/42f730f5-aab1-4168-8558-489ad8ebe93f/images/7da3f9d119b816d5b6d6ace23478cd78856feb61a3bd03fe478a4b26988f5e8e.jpeg",
  },
];

export const faqs = [
  {
    q: "How do I join under GVRewards?",
    a: "Sign up on Stake.com using code GREENVENOM or click the \u201cPlay Now\u201d button. Once registered, create an account here and connect your Stake username in Settings.",
  },
  {
    q: "What bonuses do I get?",
    a: "You get Double Weekly (your Stake weekly bonus matched and doubled), 10% lossback on weekly losses, milestone rewards up to $200K, and monthly leaderboard prizes.",
  },
  {
    q: "How does the Double Weekly work?",
    a: "Every Saturday, submit your Stake weekly bonus amount. We match and double it \u2014 up to $5,000 per week. Payouts are sent directly to your USDC (ERC20) address after verification.",
  },
  {
    q: "How do I claim milestone rewards?",
    a: "Your wager is tracked automatically once your Stake account is verified. When you hit a tier threshold, the claim button unlocks. Submit the claim and our team processes the payout.",
  },
  {
    q: "How long do payouts take?",
    a: "Most claims are processed within 24 hours. You can track your claim status in your account bonuses page at any time.",
  },
  {
    q: "How does the monthly leaderboard work?",
    a: "Each month, the top wagering players on GVRewards compete for the prize pool. Wagers are tracked automatically once your Stake account is verified, and the leaderboard resets at the start of each month.",
  },
];
